import React from 'react';
import { Star, Quote } from 'lucide-react';
import { reviews } from '../data/mock';

const ReviewsSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-[#722F37]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-white/70 text-sm font-medium tracking-widest uppercase mb-4">
            Müşteri Yorumları
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white mb-6">
            Müşterilerimiz Ne Diyor?
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-white/90 text-lg ml-2">4.9 / 5 Google</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-white/10 backdrop-blur-sm p-8 relative"
            >
              <Quote className="w-8 h-8 text-white/20 absolute top-6 right-6" />
              
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              <p className="text-white/90 leading-relaxed mb-6">
                "{review.text}"
              </p>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white font-semibold">{review.name}</p>
                  <p className="text-white/50 text-sm">{review.date}</p>
                </div>
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <span className="text-white font-semibold text-sm">
                    {review.name.charAt(0)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews Link */}
        <div className="text-center mt-12">
          <a
            href="https://www.google.com/maps/place/Kosoval%C4%B1+D%C3%B6ner+1990+Esenler"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white border border-white/30 px-6 py-3 hover:bg-white hover:text-[#722F37] transition-all duration-200"
          >
            Tüm Google Yorumlarını Gör
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;